import {Component, OnInit, ViewChild} from '@angular/core';
import {AutorizacaoService} from "../services/autorizacao.service";
import {ConstantsService} from "../fidelidade/ConstantsService";
import {EmpresasService} from "../superadmin/services/empresas.service";
import {DialogService} from "@progress/kendo-angular-dialog";
import {ActivatedRoute, Router} from "@angular/router";
import {NgForm} from "@angular/forms";
import {Produtos2Component} from "../superadmin/produtos2/produtos2.component";

@Component({
  selector: 'app-tela-cadastro-produtos',
  templateUrl: './tela-cadastro-produtos.component.html',
  styleUrls: ['./tela-cadastro-produtos.component.scss']
})
export class TelaCadastroProdutosComponent implements OnInit {
  empresa;
  usuario: any = {};
  confirmeRemover = false;
  removendo = false;
  temModuloTabelaPrecos = false;
  priceTablesPanelOpen = false;
  abrirTabelaPrecosPelaUrl = false;

  @ViewChild('telaProdutos', {static: false}) telaProdutos: Produtos2Component;
  constructor(private constantsService: ConstantsService, private autorizacaoService: AutorizacaoService,
              private router: Router,
              private empresaService: EmpresasService, private dialogService: DialogService,   private activatedRoute: ActivatedRoute) {


  }

  ngOnInit() {
    this.usuario = this.autorizacaoService.getUser() || {};
    this.constantsService.moduloTabelaPrecos$.subscribe((ativo) => {
      this.temModuloTabelaPrecos = !!ativo;
      if (this.temModuloTabelaPrecos && this.abrirTabelaPrecosPelaUrl)
       this.abraTabelaPrecos();
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      this.abrirTabelaPrecosPelaUrl = params.tabelasPrecos === '1';
      if (this.abrirTabelaPrecosPelaUrl && this.temModuloTabelaPrecos)
        this.abraTabelaPrecos();
    });
    this.constantsService.empresa$.subscribe( data => {
        this.empresa  = data
        if(this.empresa?.catalogo){
          if(this.activatedRoute.snapshot.params.id){
              setTimeout(() => {
                this.telaProdutos.abrirTelaEditarProduto(this.activatedRoute.snapshot.params.id)
              }, 200)
          }
        }
    })
  }

  abraTabelaPrecos() {
    this.router.navigateByUrl('/admin/tabelas-precos').then( () => {
    });
  }

  fecheTabelaPrecos() {
    this.priceTablesPanelOpen = false;
  }

  abraEditorProdutoLegado(produtoId: number) {
    this.fecheTabelaPrecos();
    setTimeout(() => {
      this.telaProdutos?.abrirTelaEditarProduto(produtoId);
    }, 0);
  }

  removerCatalogo(){
  //  this.confirmeRemover = true;
    this.openConfirm();
  }

  async limparCache(){
    const response: any = await fetch('/empresas/me/cache/reset');

    if(response.status === 200)   window.location.reload();
    else alert('Erro Http ' + response.status + ": " + response.statusText)
  }

  removaCatalogo(){
    this.removendo = true;

    this.empresaService.limpeCatalogoDaLoja( ).then((resposta: any) => {
      window.location.reload();
    }).catch((err) => {
      this.removendo = false;
      alert(err);

    })
  }

  public openConfirm(): void {
    const dialog: any = this.dialogService.open({
      title: 'Confirmação',
      content: 'Você tem certeza quer remover? serão removidos todas as categorias e produtos da loja',
      actions: [
        {text: 'Confirmar', primary: true},
        {text: 'Cancelar'}
      ]
    });

    dialog.result.subscribe((result) => {
      if (result.text === 'Confirmar')
        this.removaCatalogo();
    });
  }

}
